import { Button, Col, Form, Input, message, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import DoctorService from "../../../Services/DoctorService";
import TextArea from "antd/es/input/TextArea";
import e from "cors";

function Referal({ handleCancel, selectedPatient }) {
  const [doctors, setDoctors] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [chronicData, setChronicData] = useState([]);
  const [form] = Form.useForm();
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
  const [doctorSpecialties, setDoctorSpecialties] = useState([]);
  const [referDescription, setReferDescription] = useState("");
  const [openSpeciality, setOpenSpeciality] = useState(false);
  const [selectedSpeciality, setSelectedSpeciality] = useState(null);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchDoctorList(null);
    getChronicData();
    getSpecialities();
    form.setFieldsValue({
      patientName: `${selectedPatient?.firstName} ${selectedPatient?.lastName}`,
    });
  }, []);

  const getSpecialities = async (data = {}) => {
    let payload = {
      ...data,
      status: 1,
    };
    try {
      const response = await DoctorService.getDoctorSpeciality(payload);
      if (response) {
        setDoctorSpecialties(response.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchDoctorList = async (filterVal) => {
    const payload = { account_Id: loggedUser?.user?.account_Id, status: 1 };
    let finalPayload;
    if (filterVal) {
      finalPayload = {
        ...payload,
        ...filterVal,
      };
    }
    try {
      const response = await DoctorService.getDoctors(
        filterVal ? finalPayload : payload
      );
      setDoctors(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const getChronicData = async () => {
    try {
      const response = await DoctorService.chronicList({ status: 1 });
      setChronicData(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleDocChange = (id) => {
    const selectedDoctor = doctors.find((doc) => doc.userId === id);
    if (selectedDoctor) setSelectedDoc(selectedDoctor);
  };

  const handleDocSearch = async (label) => {
    if (label && label.length >= 2) {
      const payload = {
        firstName: label,
      };
      await fetchDoctorList(payload);
    } else {
      await fetchDoctorList(null);
    }
  };

  const handleReferSave = async (e) => {
    e.preventDefault();
    try {
      await form.validateFields();

      const payload = form.getFieldValue();
      payload.patientId = selectedPatient?.patientId;
      payload.createdBy = loggedUser.user.userId;
      payload.referBy = loggedUser.user.userId;
      payload.modifiedBy = loggedUser.user.userId;
      payload.status = 1;
      payload.referType = "D";
      payload.hyperLinkUrl = "";
      payload.referByAccount_Id = loggedUser.user.account_Id;
      payload.referByClinic_Id = loggedUser.user.clinic_Id;
      payload.description = referDescription;

      const result = await DoctorService.referToSave(payload);
      if (result.data.data === 1) {
        message.success("Referred Successfully");
        form.resetFields();
        handleCancel();
      } else {
        message.error("Failed to Refer. Please try after sometime.");
      }
    } catch (error) {
      message.error("Please fill out all required fields correctly.");
    }
  };

  const handleSpecialityChange = async (code) => {
    if (code) {
      const payload = {
        specialityCode: code,
        // account_Id: loggedUser.user.userId,
        status: 1,
      };
      const response = await DoctorService.getDoctors(payload);
      setDoctors(response.data);
    }
  };

  return (
    <div>
      <Form form={form} layout="vertical">
        <Row gutter={20} className="mt-5">
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            {/* <div className="relative">

              <input disabled placeholder="" value={${selectedPatient?.firstName} ${selectedPatient?.lastName}}
                className="w-[225px] h-[35px] p-2 border-2 border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans peer  focus:border-blue-500 text-[#333] bg-transparent" />

              <label className="text-xs font-medium font-sans text-[#AEAEB2] absolute left-2  transition-all peer-placeholder-shown:top-2 peer-placeholder-shown:text-xs  peer-focus:-top-2 peer-focus:text-blue-500 peer-focus:text-xs bg-white px-1">
                Patient Name
              </label>
            </div> */}
            <div className="relative">
              <span className="absolute -top-2 z-10 left-2   px-1 bg-white text-xs text-[#AEAEB2]  ">
                Patient Name
              </span>
              <Form.Item name="PatientName">
                <Input
                  disabled
                  placeholder=""
                  defaultValue={`${selectedPatient?.firstName} ${selectedPatient?.lastName}`}
                  style={{
                    width: "225px",
                    height: "34px",
                    padding: "8px",
                    background: "white",
                    border: "2px solid #e6e6ea",
                  }}
                />
              </Form.Item>
            </div>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              name="speciality"
              rules={[{ required: true, message: "Doctor is required" }]}
            >
              <Select
                className="w-[202px] h-[35px] border rounded-lg cursor-pointer bg-[#F5FEFA]"
                placeholder="Speciality"
                allowClear
                showSearch
                onChange={handleSpecialityChange}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={doctorSpecialties?.map((spec) => {
                  return {
                    label: spec.speciality,
                    value: spec.code,
                  };
                })}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              // label="Doctor"
              name="referTo"
              rules={[{ required: true, message: "Doctor is required" }]}
            >
              <Select
                showSearch
                allowClear
                className="w-[202px] h-[35px]  border rounded-lg cursor-pointer bg-white mt-2"
                placeholder="Doctor"
                onSearch={handleDocSearch}
                onChange={handleDocChange}
                options={doctors
                  .filter((doctor) => doctor.userId !== loggedUser.user.userId)
                  .map((doctor) => {
                    return {
                      label: `${doctor.firstName} ${doctor.lastName}`,
                      value: doctor.userId,
                      key: doctor.userId,
                    };
                  })}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              // label="Condition"
              name="chronicCode"
              rules={[{ required: true, message: "Condition is required" }]}
            >
              <Select
                showSearch
                allowClear
                className="w-[202px] h-[35px] border rounded-lg cursor-pointer bg-white mt-2"
                placeholder="Condition"
                options={chronicData.map((chronic) => {
                  return {
                    label: chronic.description,
                    value: chronic.code,
                    key: chronic.code,
                  };
                })}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            {/* <Input.TextArea rows={3} placeholder="Description" className="w-full mt-2" /> */}
            <div className="relative">
              <textarea
                value={referDescription}
                onChange={(e) => setReferDescription(e.target.value)}
                rows="3"
                className="w-full mt-2 border-2 outline-none rounded-md p-2 t-[32] left-[16px]  border-gray-300  focus:outline-none text-xs font-medium font-sans peer  focus:border-blue-500 text-[#333] bg-transparent"
              />
              <label className="text-xs font-medium font-sans text-[#AEAEB2] absolute left-2 top-4 transition-all peer-placeholder-shown:top-2 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#959595] peer-focus:top-0 peer-focus:text-blue-500 peer-focus:text-xs bg-white px-1">
                Description
              </label>
            </div>
          </Col>
        </Row>

        <Form.Item>
          <div className="flex justify-end gap-3 mt-3">
            <Button
              className="h-8 w-[81px] Btnwhite font-sans font-medium text-sm rounded-md text-[#189FAA]"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <button
              className="rounded-md w-32 text-white h-8 font-sans font-semibold bg-brand-primaryColor"
              type="primary"
              onClick={handleReferSave}
            >
              Refer patient
            </button>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
}

export default Referal;
